// A video over the platform's limits is refused at upload with a coded reason (PRD-0074 SC-001):
// 413 `video_too_large` (the size and the limit in GB) or `video_too_long` (the length and the
// limit in minutes). The uploader says it in the user's language, naming the file and the limit.
import type { TFunction } from 'i18next'
import { ApiError } from '@/services/api/client'

interface LimitDetail {
  code?: unknown
  limit_gb?: unknown
  size_gb?: unknown
  limit_minutes?: unknown
  duration_minutes?: unknown
}

/** The detail of a 413 refusal; null for any other failure. */
function limitDetail(error: unknown): LimitDetail | null {
  if (!(error instanceof ApiError) || error.status !== 413) return null
  const detail = (error.data as { detail?: unknown } | null | undefined)?.detail
  return detail && typeof detail === 'object' ? (detail as LimitDetail) : null
}

/** The translated reason a video upload was refused for its size or length; null for any other failure. */
export function videoLimitRefusal(error: unknown, name: string, t: TFunction): string | null {
  const detail = limitDetail(error)
  switch (detail?.code) {
    case 'video_too_large':
      return t('documents.video.limits.tooLarge', {
        name,
        limit: detail.limit_gb,
        size: detail.size_gb,
      })
    case 'video_too_long':
      return t('documents.video.limits.tooLong', {
        name,
        limit: detail.limit_minutes,
        duration: detail.duration_minutes,
      })
    default:
      return null
  }
}
